<template>
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div
          class="container-fluid d-flex flex-stack"
          id="kt_toolbar_container"
        >
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link
                    :to="{ name: 'dashboard' }"
                    class="text-muted text-hover-primary"
                  >
                    <i class="fad fa-home"></i>
                    {{ trans("Liste des requetes client") }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:content>
      
          <div class="kanban-board">
            <div
              v-for="(queries, status) in queriesByStatus"
              :key="status"
              class="kanban-column"
              :class="`kanban-column-${status.toLowerCase()}`"
              :data-status="status"
            >
              <div class="kanban-column-header">
                <h4>{{ trans(status) }}</h4>
                <span
                  class="badge badge-pill"
                  :class="`badge-${status.toLowerCase().replace('_', '-')}`"
                >
                  {{ queries.length }}
                </span>
              </div>

              <div class="kanban-column-content">
                <draggable
                  style="min-height: 50vh"
                  :list="queriesByStatusLoaded[status]"
                  group="queries"
                  @change="updateQueryStatus($event, status)"
                >
                  <div
                    v-for="query in queriesByStatusLoaded[status]"
                    :key="query.id || query.uuid"
                    class="kanban-card"
                     @click="viewQueryDetails(query)"
                  >
                    <div
                      class="kanban-card-header d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center flex-wrap">
                        <span
                          class="badge me-2"
                          :class="getStatusClass(query.status)"
                        >
                          {{ query.type || trans("Requête") }}
                        </span>
                        <span class="text-muted small">
                          {{ readableDate(query.createdAt) }}
                        </span>
                      </div>
                     
                    </div>
                    <div class="kanban-card-body">
                      <h6 class="mb-2 fw-bold text-dark">
                        {{
                          query.data?.object || trans("Détails de la requête")
                        }}
                      </h6>
                      <p class="text-muted mb-2 ">
                        {{
                          query.data?.description || trans("Aucune description")
                        }}
                      </p>
                    </div>
                    <div
                      class="kanban-card-footer d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <i class="fad fa-user-circle me-2 text-primary"></i>
                        <small class="text-muted">
                          {{
                            query.customer?.name ||
                            query.customer?.prename ||
                            trans("Client")
                          }}
                        </small>
                      </div>

                      <b-modal
                        :id="'modalQueryDetails' + query.id"
                      
                        size="lg"
                        no-footer
                        centered
                        :title="trans('Détails de la requête')"
                      >
                        <div v-if="selectedQuery" class="query-details-modal">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="card mb-4">
                                <div class="card-body">
                                  <h4 class="card-title mb-3 fw-bold">
                                    <span
                                      class="badge me-2"
                                      :class="
                                        getStatusClass(selectedQuery.status)
                                      "
                                    >
                                      {{ selectedQuery.type }}
                                    </span>
                                    {{
                                      selectedQuery.data?.object ||
                                      trans("Détails de la requête")
                                    }}
                                  </h4>
                                  <p class="text-muted mb-3">
                                    {{
                                      selectedQuery.data?.description ||
                                      trans("Aucune description")
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card">
                                <div class="card-body">
                                  <h5 class="card-title mb-3">
                                    {{ trans("Statut") }}
                                  </h5>
                                  <div class="d-flex align-items-center">
                                    <span
                                      class="badge me-2 fs-6"
                                      :class="
                                        getStatusClass(selectedQuery.status)
                                      "
                                    >
                                      {{ selectedQuery.status }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title mb-3">
                                {{ trans("Informations supplémentaires") }}
                              </h5>
                              <div class="row">
                                <div class="col-md-4 mb-2">
                                  <strong>{{ trans("Client") }}:</strong>
                                  <p class="text-muted">
                                    {{
                                      selectedQuery.customer?.name ||
                                      selectedQuery.customer?.prename ||
                                      trans("Non spécifié")
                                    }}
                                  </p>

                                  Email: {{ selectedQuery.customer?.email }}
                                  Téléphone: {{ selectedQuery.customer?.phone }}

                                 
                                </div>
                                <div class="col-md-4 mb-2">
                                  <strong
                                    >{{ trans("Date de création") }}:</strong
                                  >
                                  <p class="text-muted">
                                    {{ readableDate(selectedQuery.createdAt) }}
                                  </p>
                                </div>

                                <div
                                  v-if="selectedQuery.data.source"
                                  class="col-md-4 mb-2"
                                >
                                  <router-link
                                    :to="{
                                      name:
                                        selectedQuery.data.source === 'CONTRAT'
                                          ? 'contract-show'
                                          : '',
                                      params: { contractUuid: selectedQuery.data.reference },
                                    }"
                                  >
                                    <button class="btn btn-primary btn-sm">
                                      <i class="fad fa-eye"></i> Consulter
                                    </button></router-link
                                  >
                                </div>
                              </div>
                              <div v-if="selectedQuery.file">
                                <div class="mb-2">
                                  <strong>{{ trans("Document") }}:</strong>
                                  <iframe
                                    height="500px"
                                    width="100%"
                                    :src="uploadRoot + selectedQuery.file"
                                    frameborder="0"
                                  ></iframe>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      
                      </b-modal>
                    </div>

                    <!-- <div class="kanban-card-header">
                      <router-link 
                        :to="{ name: 'query-details', params: { uuid: query.uuid } }"
                        class="text-gray-800 text-hover-primary fw-bolder"
                      >
                        {{ query.label || trans('Requête sans nom') }}
                      </router-link>
                      <span class="badge badge-light-primary ml-2">
                        {{ query.type }}
                      </span>
                    </div>
                    
                    <div class="kanban-card-body">
                      <div class="text-muted mb-2">
                        {{ query.description }}
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="text-muted" :title="readableDate(query.createdAt)">
                          {{ timelapse(query.createdAt) }}
                        </span>
                        <div class="d-flex">
                          <button 
                            v-if="status === 'PENDING'"
                            class="btn btn-icon btn-sm btn-light-danger me-2" 
                            @click="cancelQuery(query)"
                          >
                            <i class="fad fa-times"></i>
                          </button>
                          <button 
                            v-if="status === 'PENDING'"
                            class="btn btn-icon btn-sm btn-light-success" 
                            @click="validateQuery(query)"
                          >
                            <i class="fad fa-check"></i>
                          </button>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </draggable>

              </div>
            </div>
          </div>
        
        <div class=" d-flex justify-content-center">
          <button class="btn " @click="loadQueriesGlobal(pageGlobal+1)">Voir plus</button>
        </div>
    </template>
  </Base>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import Pagination from "@/components/Pagination.vue";
import Loading from "@/components/Loading.vue";
import RowSelector from "@/components/RowSelector.vue";
import DateRangePicker from "vue2-daterange-picker";
import BooleanInput from "@/components/BooleanInput.vue";
import draggable from "vuedraggable";
import { api } from "@/services/Api";
import router from "@/router";
import Popup from "@/entity/Popup";

// Type definition for query status
type QueryStatus = "PENDING" | "IN_PROGRESS" | "DONE" | "CANCELLED" | "FAILED";

// Declare Vue instance properties for type checking
declare module "vue/types/vue" {
  interface Vue {
    $api: any;
    $toast: any;
  }
}

@Component({
  components: {
    Base,
    Pagination,
    Loading,
    RowSelector,
    DateRangePicker,
    BooleanInput,
    draggable,
  },
})
export default class QueryList extends Vue {
  queries: any[] = [];
  total = 0;
  matchCount = 0;
  isLoading = false;

  uploadRoot = api.uploadRoot;

  searched = {
    type: null,
    status: null,
    page: 1,
    perPage: 10,
  };

  private isValidStatus(status: string): status is QueryStatus {
    const statuses: QueryStatus[] = [
      "PENDING",
      "IN_PROGRESS",
      "DONE",
      "CANCELLED",
      "FAILED",
    ];
    return statuses.includes(status as QueryStatus);
  }

  get queriesByStatus() {
    const statuses: QueryStatus[] = [
      "PENDING",
      "IN_PROGRESS",
      "DONE",
      "CANCELLED",
      "FAILED",
    ];

    const groupedQueries: { [K in QueryStatus]: any[] } = {
      PENDING: [],
      IN_PROGRESS: [],
      DONE: [],
      CANCELLED: [],
      FAILED: [],
    };

    const processQuery = (query: any) => {
      if (query && typeof query === "object" && query.status) {
        const status = query.status.toUpperCase() as QueryStatus;
        if (statuses.includes(status)) {
          groupedQueries[status].push(query);
        }
      }
    };

    // console.log(this.queries, 'queries')

    this.queries.forEach((query) => {
      //  console.log('mapping')
      processQuery(query);
    });

    return groupedQueries;
  }

  mounted() {
    this.loadFirstPageGlobal();
  }

  async loadFirstPageGlobal() {
    this.pageGlobal = 1;
    await this.loadQueriesGlobal(1);
  }

  async loadQueriesGlobal(page = 1) {
    const pop = new Popup('Chargement', `Chargement des requêtes`, 'primary', 'fad fa-cogs', true)
    try {
      const response = await api.get(api.auth, "queries/list", {
        params: {
          page,
          perPage: this.perPageGlobal,
        },
      });
      const queries = response.data.queries;
      // Répartir dans chaque colonne
      if (page === 1) {
        this.queriesByStatusLoaded = {
          PENDING: [],
          IN_PROGRESS: [],
          DONE: [],
          CANCELLED: [],
          FAILED: [],
        };
      }
      if (queries && typeof queries === 'object' && !Array.isArray(queries)) {
        Object.keys(this.queriesByStatusLoaded).forEach((status) => {
          const items = queries[status] || [];
          this.queriesByStatusLoaded[status] = page === 1 ? [...items] : [
            ...(this.queriesByStatusLoaded[status] || []),
            ...items
          ];
        });
      } else if (Array.isArray(queries)) {
        // fallback si jamais c'est un array (rare)
        queries.forEach((q: any) => {
          if (q.status && this.queriesByStatusLoaded[q.status.toUpperCase()]) {
            this.queriesByStatusLoaded[q.status.toUpperCase()].push(q);
          }
        });
      }
      this.pageGlobal = page;
      this.totalCount = response.data.total || 0;
    } catch (error) {
      const pop = new Popup('Chargement', `Erreur lors du chargement des requêtes`, 'danger', 'fad fa-cogs', true)
      console.error("Query loading error:", error);
    } finally {
      pop.hide();
    }
  }


  getStatusClass(status: QueryStatus | string): string {
    const statusClasses: { [K in QueryStatus]: string } = {
      PENDING: "badge-warning",
      IN_PROGRESS: "badge-primary",
      DONE: "badge-success",
      CANCELLED: "badge-secondary",
      FAILED: "badge-danger",
    };

    const normalizedStatus = (status as string).toUpperCase() as QueryStatus;
    return this.isValidStatus(normalizedStatus)
      ? statusClasses[normalizedStatus]
      : "badge-light";
  }

  search() {
    this.loadQueriesGlobal();
  }

  resetSearch() {
    this.searched = {
      type: null,
      status: null,
      page: 1,
      perPage: 10,
    };
    this.loadQueriesGlobal();
  }

  async updateQueryStatus(event: any, targetStatus?: string) {
    console.log(event, "event");
    try {
      const statuses: QueryStatus[] = [
        "PENDING",
        "IN_PROGRESS",
        "DONE",
        "CANCELLED",
        "FAILED",
      ];

      if (event.moved) {
        return;
      }

      if (event.added ) {
        const { element } = event.added;
        const newStatus =
          targetStatus ||
          statuses.find(
            (status) =>
              status === event.added.to.closest(".kanban-column").dataset.status
          );


        await api.post(api.auth, `queries/${element.id}/status`, {
          status: newStatus,
        });

        this.loadQueriesGlobal();
      }


      // if (event.removed ) {
      //   const { element } = event.removed;
      //   const newStatus =
      //     targetStatus ||
      //     statuses.find(
      //       (status) =>
      //         status === event.removed.to.closest(".kanban-column").dataset.status
      //     );


      //   await api.post(api.auth, `queries/${element.id}/status`, {
      //     status: newStatus,
      //   });

      //   this.loadQueriesGlobal();
      // }
    } catch (error) {
      console.error(error);
      const pop = new Popup('Chargement', 'Erreur lors de la mise à jour du statut', 'danger', 'fad fa-cogs', true)
    }
  }

  showModal = false;
  selectedQuery: any = null;
  visibleCountByStatus: Record<string, number> = {};
  // Pagination globale
  pageGlobal: number = 1;
  perPageGlobal: number = 20;
  queriesByStatusLoaded: Record<string, any[]> = {
    PENDING: [],
    IN_PROGRESS: [],
    DONE: [],
    CANCELLED: [],
    FAILED: [],
  };
  totalCount: number = 0;
  isLoadingMore: boolean = false;

  get totalLoaded(): number {
    return Object.values(this.queriesByStatusLoaded).reduce((sum, arr) => sum + arr.length, 0);
  }

  viewQueryDetails(query: any) {
    this.selectedQuery = query;
    this.$bvModal.show("modalQueryDetails" + query.id);
  }

  closeModal() {
    this.showModal = false;
    this.selectedQuery = null;
  }

  async showMore() {
    this.isLoadingMore = true;
    const nextPage = this.pageGlobal + 1;
    await this.loadQueriesGlobal(nextPage);
    this.isLoadingMore = false;
  }

  async cancelQuery(query: any) {
    try {
      await this.$api.post(`/queries/${query.uuid}/cancel`);
      const pop = new Popup('Chargement', 'Requête annulée', 'success', 'fad fa-cogs', true)
      this.loadQueriesGlobal();
    } catch (error) {
      const pop = new Popup('Chargement', 'Erreur lors de l\'annulation de la requête', 'danger', 'fad fa-cogs', true)
    }
  }

  async validateQuery(query: any) {
    try {
      await this.$api.post(`/queries/${query.uuid}/validate`);
      const pop = new Popup('Chargement', 'Requête validée', 'success', 'fad fa-cogs', true)
      this.loadQueriesGlobal();
    } catch (error) {
      const pop = new Popup('Chargement', 'Erreur lors de la validation de la requête', 'danger', 'fad fa-cogs', true)
    }
  }
}
</script>

<style scoped>
.p-0 .b-dropdown-text {
  padding: 0;
}

.kanban-board {
  display: flex;
  overflow-x: auto;
  padding: 1rem 0;
}

.kanban-board {
  display: flex;
  overflow-x: auto;
  padding: 1rem 0;
  gap: 1rem;
}

.kanban-column {
  flex: 0 0 300px;
  background-color: #f4f4f4;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.kanban-column-header {
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.kanban-column-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
}

.kanban-column-header .badge {
  font-size: 0.75rem;
}

.kanban-column-content {
  /* max-height: 60vh; */
  overflow-y: auto;
  padding: 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.kanban-column-content::-webkit-scrollbar {
  width: 6px;
}

.kanban-column-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.kanban-card {
  background-color: white;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid transparent;
}

.kanban-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: rgba(0, 123, 255, 0.25);
}

.kanban-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.kanban-card-body {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.kanban-card-body h6 {
  color: #495057;
  margin-bottom: 0.25rem;
}

.kanban-card-body p {
  color: #868e96;
  line-height: 1.4;
}

.kanban-card-footer {
  border-top: 1px solid #e9ecef;
  padding-top: 0.5rem;
  margin-top: 0.5rem;
}

.kanban-column-pending .kanban-column-header {
  background-color: #ffc107;
  color: white;
}
.kanban-column-in_progress .kanban-column-header {
  background-color: #007bff;
  color: white;
}
.kanban-column-done .kanban-column-header {
  background-color: #28a745;
  color: white;
}
.kanban-column-cancelled .kanban-column-header {
  background-color: #6c757d;
  color: white;
}
.kanban-column-failed .kanban-column-header {
  background-color: #dc3545;
  color: white;
}
</style>